import HTMLTemplate from './template.html'
import tippy, { followCursor } from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/animations/shift-away.css'
import { Settings } from '../Settings/Settings'
import MaritimeAlerts from '../../modules/maritimeAlerts'
import User from '../../modules/user'
import { ApplicationInfoModalComponent } from '../ApplicationInfo/ApplicationInfo'
import MixPanelService from '../../services/MixPanelService'

export const AlertBarBottom = (() => {
    const vueComponent = {
        data() {
            return {
                lastLiveEventHeadline: '',
                lastLiveEventType: '',
                lastLiveMaritimeAlertTypeId: ''
            }
        },
        created() {
            document.getElementById('app-loading-screen').classList.add('has-bottom-bar')
            User.getUserPermissions().then(permissions => {
                if (permissions[0] === 'medical' && permissions.indexOf('basic') === -1) {
                    // Medical users only should see only Alerts type application info, so we set display to false for all others
                    ApplicationInfoModalComponent.$data.applicationInfo.forEach(appInfo => {
                        if (appInfo.type !== 'Alerts') appInfo.display = false
                    })
                }

                // Hide airport code setting if user has medical or comprehensive_crew_support permissions only
                if ((permissions.includes('medical') || permissions.includes('comprehensive_crew_support')) && permissions.indexOf('basic') === -1) {
                    Settings.$data.showAirportCodeSetting = false
                }
            })
        },
        methods: {
            showAlertFlyout() {
                document.getElementsByClassName('app-template')[0].classList.add('event-panel-show')
                MixPanelService.track('Alerts panel View - Latest Alerts', {
                    'Clicked Location': 'Bottom Bar'
                })
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-alert-bar-bottom')

    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).use({
            install: (app) => {
                app.directive('tooltip', {
                    beforeMount(el, binding) {
                        tippy(el, {
                            content: binding.value,
                            placement: 'bottom-start',
                            animation: 'shift-away',
                            allowHTML: true,
                            trigger: 'mouseenter',
                            arrow: false,
                            followCursor: true,
                            plugins: [followCursor]
                        })
                    }
                })
            }
        }).mount(DOMElement)
    }
})()
